import styled from "styled-components";
import { DefaultButton } from "./defaultButton";

export const SecondaryButton = styled(DefaultButton)`
	background-color: ${({ theme }) => theme.colors.primaryLight};
	color: ${({ theme }) => theme.colors.primary};
	svg {
		margin-right: 4px;
		path {
			fill: ${({ theme }) => theme.colors.primary};
		}
	}

	transition: background-color 0.2s linear;
	&:hover {
		background-color: ${({ theme }) => theme.colors.primaryLightTouch};
	}
`;
